import React from "react";
import { Instagram, Heart } from "lucide-react";
import { INSTA_GRID } from "../mock";

const LovedBy = () => {
  return (
    <section className="bg-[#FFE4D6]">
      <div className="max-w-7xl mx-auto px-4 py-16 md:py-24">
        <div className="text-center mb-10">
          <div className="text-[11px] uppercase tracking-[0.35em] text-[#DD4D2A] font-semibold mb-3">
            @georgeventurebrands
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1A1410]">
            Loved By <span className="italic">Thousands!</span>
          </h2>
          <p className="mt-4 text-[#1A1410]/70">Over 2M Views On Instagram</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {INSTA_GRID.map((src, i) => (
            <a
              key={i}
              href="#"
              className="group relative block aspect-square rounded-2xl overflow-hidden bg-[#FFF2EC]"
            >
              <img
                src={src}
                alt="Instagram post"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#1A1410]/0 group-hover:bg-[#1A1410]/50 transition-colors flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-4 text-white">
                  <div className="flex items-center gap-1.5">
                    <Heart className="w-5 h-5 fill-white" />
                    <span className="text-sm font-semibold">
                      {(i + 1) * 1234}
                    </span>
                  </div>
                  <Instagram className="w-5 h-5" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LovedBy;
